import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { LangProvider } from "@/context/LangContext";
import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import AuthorPage from "@/pages/AuthorPage";
import ContactPage from "@/pages/ContactPage";
import SuggestionsPage from "@/pages/SuggestionsPage";
import ContributePage from "@/pages/ContributePage";
import PrivacyPage from "@/pages/PrivacyPage";
import TermsPage from "@/pages/TermsPage";
import BlogPage from "@/pages/BlogPage";
import ArticlePage from "@/pages/ArticlePage";
import AcceptInvitePage from "@/pages/AcceptInvitePage";
import LoginPage from "@/pages/admin/LoginPage";
import DashboardPage from "@/pages/admin/DashboardPage";

function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === undefined) {
    return <div className="min-h-screen grid place-items-center bg-background text-muted-foreground">Loading…</div>;
  }
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}

function App() {
  return (
    <BrowserRouter>
      <LangProvider>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/sobre" element={<AboutPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/autor" element={<AuthorPage />} />
            <Route path="/contacto" element={<ContactPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/sugestoes" element={<SuggestionsPage />} />
            <Route path="/suggestions" element={<SuggestionsPage />} />
            <Route path="/contribuir" element={<ContributePage />} />
            <Route path="/contribute" element={<ContributePage />} />
            <Route path="/privacidade" element={<PrivacyPage />} />
            <Route path="/termos" element={<TermsPage />} />
            <Route path="/blog/:blog" element={<BlogPage />} />
            <Route path="/blog/:blog/:slug" element={<ArticlePage />} />
            <Route path="/accept-invite" element={<AcceptInvitePage />} />
            <Route path="/admin/login" element={<LoginPage />} />
            <Route path="/admin" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AuthProvider>
      </LangProvider>
    </BrowserRouter>
  );
}

export default App;
